import * as getters from "../../baseQuestion/date/store/getters";
import * as mutations from "../../baseQuestion/date/store/mutations";
import * as actions from "../../baseQuestion/date/store/actions";
import { state as base_state } from "../../baseQuestion/date/store/state";

function state() {
	return Object.assign(
		{
			dependent_visible: "q_armed_forces_status",
			dependent_visible_values: ["C", "P"]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
